// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__lKQbM","rowsWrapper":"style_rowsWrapper__2X3mP","rowWrapper":"style_rowWrapper__15i1x"};